// extracted by mini-css-extract-plugin
export default {"form-text":"styles_form-text__OJH39"};